var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        width: 1000,
        title: _vm.title,
        visible: _vm.innerVisible,
        cancelText: "关闭",
        okButtonProps: { style: { display: "none" } },
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-alert",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { type: "info", showIcon: "" },
        },
        [
          _c(
            "template",
            { slot: "message" },
            [
              _c("span", [_vm._v("已选择")]),
              _c(
                "a",
                { staticStyle: { "font-weight": "600", padding: "0 4px" } },
                [_vm._v(_vm._s(_vm.selectedRowKeys.length))]
              ),
              _c("span", [_vm._v("项")]),
              _vm.selectedRowKeys.length > 0
                ? [
                    _c("a-divider", { attrs: { type: "vertical" } }),
                    _c("a", { on: { click: _vm.handleClearSelection } }, [
                      _vm._v("清空选择"),
                    ]),
                    _c("a-divider", { attrs: { type: "vertical" } }),
                    _c("a", { on: { click: _vm.handleRevertBatch } }, [
                      _vm._v("批量还原"),
                    ]),
                    _c("a-divider", { attrs: { type: "vertical" } }),
                    _c("a", { on: { click: _vm.handleDeleteBatch } }, [
                      _vm._v("批量删除"),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c("a-table", {
        ref: "table",
        attrs: {
          rowKey: "id",
          size: "middle",
          bordered: "",
          columns: _vm.columns,
          loading: _vm.loading,
          dataSource: _vm.dataSource,
          rowSelection: {
            selectedRowKeys: _vm.selectedRowKeys,
            onChange: _vm.handleTableSelectChange,
          },
        },
        scopedSlots: _vm._u([
          {
            key: "avatarslot",
            fn: function (text, record, index) {
              return [
                _c(
                  "div",
                  { staticClass: "anty-img-wrap" },
                  [
                    _c("a-avatar", {
                      attrs: {
                        shape: "square",
                        src: _vm.url.getAvatar(record.avatar),
                        icon: "user",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "action",
            fn: function (text, record) {
              return _c(
                "span",
                {},
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleRevert([record.id])
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "redo" } }),
                      _vm._v("\n        还原用户\n      "),
                    ],
                    1
                  ),
                  _c("a-divider", { attrs: { type: "vertical" } }),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleDelete([record.id])
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "delete" } }),
                      _vm._v("\n        彻底删除\n      "),
                    ],
                    1
                  ),
                ],
                1
              )
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }